module.exports = __webpack_public_path__ + "static/media/alexander-400-400.59c76ddf.png";